<div class="faq-container">
  <div class="faq-nav-bar box">
    <div class="faq-nav-bar-title">{{ faqTitle }}</div>
    <div class="faq-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="faq-holder">
    <div class="box faq-table" *ngIf="faqs">
      <div
        *ngFor="let faq of faqs.faqs; let i = index"
        class="faq-cell box"
        [ngStyle]="{
          'margin-top': '0'
        }"
        (click)="goToAnswer(faq._id)"
      >
        <div class="faq-cell-title">{{ faq.question }}</div>
        <img class="faq-cell-more-icon" src="assets/general/left-black.svg" />
      </div>
    </div>
  </div>
</div>
